import React from "react";
import { Moon, Clock, CircleCheck, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ReinigungBeiNacht() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="reinigung-bei-nacht" ref={ref} className={`dark bg-background text-foreground py-24 relative overflow-hidden transition-opacity duration-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
      {}
      <div className="absolute top-0 right-0 w-1/3 h-full bg-primary/5 -skew-x-12 pointer-events-none" />
      <div className="absolute bottom-0 left-0 w-64 h-64 bg-primary/5 rounded-full blur-3xl pointer-events-none" />

      <div className="container mx-auto px-6 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {}
          <div className="space-y-8">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary/10 text-primary text-sm font-medium tracking-wide uppercase">
              <Moon className="w-4 h-4" />
              <span>Nachtservice&nbsp;</span>
            </div>

            <h2 className="text-4xl md:text-5xl font-bold tracking-tight text-white leading-tight">
              Reinigung ohne <span className="text-primary">Stillstand</span>.
              <br />
              Wir arbeiten, wenn Sie schlafen.
            </h2>

            <div className="space-y-6 text-lg text-muted-foreground">
              <p>Stillstände kosten Zeit, Geld und Organisation. Deshalb reinigen wir konsequent außerhalb Ihrer Öffnungszeiten – effizient, abgestimmt und so, dass am nächsten Morgen alles einsatzbereit ist.</p>
              <p>Keine Absperrungen im Tagesbetrieb, keine blockierten Wege, keine Störung Ihrer Abläufe. Wir arbeiten diskret im Hintergrund und liefern ein sauberes Ergebnis bis zur Öffnung</p>
            </div>

            <div className="pt-4">
              <Button asChild size="lg" className="text-base font-semibold">
                <Link to="/ContactPage">Angebot anfragen<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-arrow-right ml-2 w-4 h-4" aria-hidden="true" data-ast-id="f:/src/pages/Home/sections/ReinigungBeiNacht.tsx|sig:1rkuqo" data-ast-start="2544" data-ast-end="2583"><path d="M5 12h14"></path><path d="m12 5 7 7-7 7"></path></svg></Link>
              </Button>
            </div>
          </div>

          {}
          <div className="relative">
            {}
            <div className="relative bg-white/5 backdrop-blur-md border-l-4 border-primary rounded-r-xl p-8 md:p-10 shadow-2xl overflow-hidden group hover:bg-white/10 transition-colors duration-300">
              {}
              <Clock className="absolute -right-6 -bottom-6 w-48 h-48 text-white/5 group-hover:text-primary/10 transition-colors duration-500 rotate-12" />

              <div className="relative z-10 space-y-6">
                <h3 className="text-2xl font-bold text-white flex items-center gap-3">
                  <span className="p-2 bg-primary/20 rounded-lg text-primary">
                    <CircleCheck className="w-6 h-6" />
                  </span>
                  Ihre Vorteile
                </h3>

                <ul className="space-y-4">
                  {["Ohne Ausfallzeiten", "Bundesweit im Einsatz", "Schützt vor teuren Reparaturen", "Sauberkeit stärkt Ihren ersten Eindruck"].map((item, i) => <li key={i} data-index={i} className="flex items-start gap-3 text-gray-300">
                      <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-primary shrink-0" />
                      <span>{item}</span>
                    </li>)}
                </ul>

                <div className="pt-4 border-t border-white/10 mt-6">
                  <p className="text-sm text-primary font-medium uppercase tracking-wider">Keine Zuschläge</p>
                  <p className="text-xs text-muted-foreground mt-1">Wir berechnen keine Nachtzuschläge für Standard-Aufträge.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}